var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash18Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1002 1.79999C7.7593 1.79999 7.44766 1.99259 7.29521 2.2975L6.64397 3.59999H3.6002C3.10314 3.59999 2.7002 4.00293 2.7002 4.49999C2.7002 4.99704 3.10314 5.39999 3.6002 5.39999L3.6002 14.4C3.6002 15.3941 4.40608 16.2 5.4002 16.2H12.6002C13.5943 16.2 14.4002 15.3941 14.4002 14.4V5.39999C14.8973 5.39999 15.3002 4.99704 15.3002 4.49999C15.3002 4.00293 14.8973 3.59999 14.4002 3.59999H11.3564L10.7052 2.2975C10.5527 1.99259 10.2411 1.79999 9.9002 1.79999H8.1002ZM6.3002 7.19999C6.3002 6.70293 6.70314 6.29999 7.2002 6.29999C7.69725 6.29999 8.1002 6.70293 8.1002 7.19999V12.6C8.1002 13.097 7.69725 13.5 7.2002 13.5C6.70314 13.5 6.3002 13.097 6.3002 12.6V7.19999ZM10.8002 6.29999C10.3031 6.29999 9.9002 6.70293 9.9002 7.19999V12.6C9.9002 13.097 10.3031 13.5 10.8002 13.5C11.2973 13.5 11.7002 13.097 11.7002 12.6V7.19999C11.7002 6.70293 11.2973 6.29999 10.8002 6.29999Z",
    fill: "#7551FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash18Px);
export default __webpack_public_path__ + "static/media/trash.18px.1f329751e628bfc45a696aa1a52fdbf3.svg";
export { ForwardRef as ReactComponent };